import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class UserService {
  currentUser: any;
  userdata: string;
  userId: any;
  constructor(private service: DataService) { 
    // let jwt = new JwtHelper();
    // if(localStorage.getItem('token')!=null)
    // {
    //      this.currentUser = jwt.decodeToken(localStorage.getItem('token'));
    //      console.log('Current user ',this.currentUser);
    //      console.log( " userData ", this.currentUser['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'] );
    //      this.userdata=this.currentUser['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'];
    //      let userdataa=this.userdata.split('|');
    //     // this.userId=userdataa[0].split('UserId:')[1]
    //     // console.log('UserId -', this.userId[0].split('UserId:')[1]);
    //   }
  }
  userEditProfile(data)
  {
    data.UserId=this.userId;
    // return this.service.create(environment.userEditProfileUrl,data);
  }
  userChangePassword(data)
  {
    data.UserId=this.userId;
    // return this.service.create(environment.userProfileUrl,data);
  }
}
